angular.module('workflow')
    .controller('WorkflowProcessingHistoryController', function (data, $uibModalInstance, Workflow) {
        this.$onInit = () => {
            Workflow.history({id: data}).$promise.then(items => this.items = items)
        }
        this.close = () => $uibModalInstance.dismiss()
    })
